<div>
    <label class="form-label">{{ label }}</label>
    <dx-select-box
        [value]="attachmentId"
        [dataSource]="dataSource"
        valueExpr="id"
        displayExpr="name"
        stylingMode="filled"
        [readOnly]="true"
    >
    </dx-select-box>
</div>
<div class="mt-2">
    <label class="mb-0">Is correct?</label>
    <dx-radio-group
        layout="horizontal"
        [items]="yesNoOptions"
        valueExpr="value"
        displayExpr="text"
        [(value)]="model.isThisIdCorrect"
        [readOnly]="readOnly"
    >
        <dx-validator>
            <dxi-validation-rule type="custom" [validationCallback]="validateYesNo" message="Selection is required"></dxi-validation-rule>
        </dx-validator>
    </dx-radio-group>
</div>
@if (model.isThisIdCorrect === false) {
    <div>
        <label class="form-label text-primary">Correct Asset ID</label>
        <dx-select-box
            [(value)]="model.correctAssetId"
            [dataSource]="dataSource"
            valueExpr="id"
            displayExpr="name"
            stylingMode="filled"
            placeholder="Correct Asset ID"
            [readOnly]="readOnly"
        >
            <dx-validator>
                <dxi-validation-rule type="required" message="Please select the correct asset"></dxi-validation-rule>
            </dx-validator>
        </dx-select-box>
    </div>
}
